export class User {
  public id: string;
  public email: string;
  public isOnboarded: boolean;

  constructor(user: any) {
    this.id = user.id;
    this.email = user.email;
    this.isOnboarded = user.isOnboarded;
  }
}
